<template>
  <div class="section has-background-light fullheight-min">
    <div class="container" >
      <slot></slot>
      <h2 class="title">Выберите документ</h2>
      <div class="columns is-multiline" >
        <div class="column is-4" v-for="(models, app) in permissions" :key="app">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">{{firstUp($tc(app))}}</p>
            </header>
            <div class="card-content">
              <ul class="models">
                <li v-for="(perms, model) in models" :key="model"><router-link :to="`dashboard/${app}/${model}`" class="button is-text">{{firstUp($tc(model))}}</router-link></li>
              </ul>
            </div>
            <div class="card-footer">
              <router-link :to="`dashboard/${app}`" class="card-footer-item has-background-light has-text-grey">Открыть все</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created () {
  },
  data () {
    return {
      models: []
    }
  },
  computed: {
    permissions () {
      return this.$store.state.user.permissions
    }
  },
  methods: {
    firstUp (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
}
</script>
<style lang="scss">
  .models li{
    list-style: none;
  }
</style>
